import React from 'react';
import { I18n } from 'aws-amplify';
import { useGroupMember } from '../../user-context';

export const GlobalHelp = () => {
    return (<>
        <h3>{I18n.get("Aide globale")}</h3>
        <hr style={{ borderTop: "1px solid #cdcbcb" }} />
        <div>
            <div className="grid">
                &#160;
            </div>
            <div className="grid">
                <div className="col">{I18n.get("Retrouvez ici tous les liens vers les différentes aides:")}</div>
            </div>
            <div className="grid">
                &#160;
            </div>
            {useGroupMember('gerants') && (<>
                <div className="grid">
                    <b><i className='pi pi-users' /> {I18n.get("Equipe")}</b>
                </div>
                <div className="grid">
                    &#160;
                </div>
                <div className="grid">
                    <div className="col"><i className='pi pi-video' /> <a style={{ color: '#000000' }} href={I18n.get("https://www.cdm.lu/mediatheque/media/comment-gerer-mon-equipe")} rel="noopener noreferrer" target="_blank">{I18n.get("Gérer mon équipe")}</a></div>
                </div>
                <div className="grid">
                    <div className="col"><i className='pi pi-video' /> <a style={{ color: '#000000' }} href={I18n.get("https://www.cdm.lu/mediatheque/media/comment-ajouter-un-tuteur-a-mon-equipe")} rel="noopener noreferrer" target="_blank">{I18n.get("Gestion des membres")}</a></div>
                </div></>)}
        </div>
    </>
    )
};